// extracted by mini-css-extract-plugin
module.exports = {"triptic":"Triptic_triptic__qjSwf","inner":"Triptic_inner__6ISjm"};